import Vue from 'vue'


// WEBPACK FOOTER //
// ./src/vendor.js